import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface Privilege {
  type: string;
  privilege: boolean;
}

interface UserData {
  id: string | null;
  employeeId?: string | number;
  firstName?: string;
  lastName?: string;
  position?: string;
  authToken?: string;
  refreshToken?: string;
  privileges?: Privilege[];
  segments?: string[];
  [key: string]: unknown;
}

interface AuthState {
  user: UserData;
  filterlist: Record<string, unknown>;
  datatype: Record<string, unknown>;
  jobschedule: Record<string, unknown>;
  provisiontype: Record<string, unknown>;
  configurationList: unknown[];
}

const initialState: AuthState = {
  user: { id: null },
  configurationList: [],
  filterlist: {},
  datatype: {},
  jobschedule: {},
  provisiontype: {},
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess(state, action: PayloadAction<UserData>) {
      state.user = action.payload;
    },
    logout() {
      return { ...initialState };
    },
    setSelectedRole(state, action: PayloadAction<unknown>) {
      (state as Record<string, unknown>).selectedRole = action.payload;
    },
    setConfigurationList(state, action: PayloadAction<unknown[]>) {
      state.configurationList = action.payload;
    },
    setFilterList(state, action: PayloadAction<Record<string, unknown>>) {
      state.filterlist = action.payload;
    },
    setDataType(state, action: PayloadAction<Record<string, unknown>>) {
      state.datatype = action.payload;
    },
    setJobSchedule(state, action: PayloadAction<Record<string, unknown>>) {
      state.jobschedule = action.payload;
    },
    setProvisionType(state, action: PayloadAction<Record<string, unknown>>) {
      state.provisiontype = action.payload;
    },
  },
});

export const {
  loginSuccess,
  logout,
  setSelectedRole,
  setConfigurationList,
  setFilterList,
  setDataType,
  setJobSchedule,
  setProvisionType,
} = authSlice.actions;

export default authSlice.reducer;
